import type {
  IMyDependencySummary,
  IMyEscalationSummary,
  IMyIssueSummary,
  IMyLedProject,
  IMyRiskSummary,
  IMyTimeSummary,
  MyFeedScope,
} from '@pulse/shared';

import { apiFetch } from '../../../lib/api-client';
import { extractErrorMessage } from '../../../lib/api-error.util';

// `mine` is the API's own default, so it goes out as a bare URL — the personal feed's request
// stays byte-identical to what it was before the Lead view existed.
function scoped(path: string, scope: MyFeedScope): string {
  return scope === 'led' ? `${path}?scope=led` : path;
}

export async function fetchMyIssues(scope: MyFeedScope = 'mine'): Promise<IMyIssueSummary[]> {
  const res = await apiFetch(scoped('/api/v1/me/issues', scope));
  if (!res.ok) throw new Error(await extractErrorMessage(res, 'Failed to fetch your issues'));
  return res.json() as Promise<IMyIssueSummary[]>;
}

export async function fetchMyRisks(scope: MyFeedScope = 'mine'): Promise<IMyRiskSummary[]> {
  const res = await apiFetch(scoped('/api/v1/me/risks', scope));
  if (!res.ok) throw new Error(await extractErrorMessage(res, 'Failed to fetch your risks'));
  return res.json() as Promise<IMyRiskSummary[]>;
}

export async function fetchMyDependencies(scope: MyFeedScope = 'mine'): Promise<IMyDependencySummary[]> {
  const res = await apiFetch(scoped('/api/v1/me/dependencies', scope));
  if (!res.ok) throw new Error(await extractErrorMessage(res, 'Failed to fetch your dependencies'));
  return res.json() as Promise<IMyDependencySummary[]>;
}

export async function fetchMyEscalations(scope: MyFeedScope = 'mine'): Promise<IMyEscalationSummary[]> {
  const res = await apiFetch(scoped('/api/v1/me/escalations', scope));
  if (!res.ok) throw new Error(await extractErrorMessage(res, 'Failed to fetch your escalations'));
  return res.json() as Promise<IMyEscalationSummary[]>;
}

export async function fetchMyLedProjects(): Promise<IMyLedProject[]> {
  const res = await apiFetch('/api/v1/me/led-projects');
  if (!res.ok) throw new Error(await extractErrorMessage(res, 'Failed to fetch the projects you lead'));
  return res.json() as Promise<IMyLedProject[]>;
}

export async function fetchMyTimeSummary(): Promise<IMyTimeSummary> {
  const res = await apiFetch('/api/v1/me/time-summary');
  if (!res.ok) throw new Error(await extractErrorMessage(res, 'Failed to fetch your time summary'));
  return res.json() as Promise<IMyTimeSummary>;
}
